"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _components = require("@folio/stripes/components");
var CUSTPROP_TYPES = _interopRequireWildcard(require("../../constants/customProperties"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertyCard = _ref => {
  let {
    ctx,
    customProperty,
    customPropertyDefinition = {},
    index,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {}
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);

  // We only need to display primary and set properties
  const toDisplay = !!(customPropertyDefinition.primary || customProperty);
  if (!toDisplay) {
    return null;
  }
  const internalFalse = (customProperty === null || customProperty === void 0 ? void 0 : customProperty.internal) === false || (customProperty === null || customProperty === void 0 ? void 0 : customProperty.internal) === undefined && customPropertyDefinition.defaultInternal === false;
  const renderValue = () => {
    var _customProperty$value, _customProperty$value2, _customProperty$value3, _customProperty$value4;
    if (!customProperty) {
      return kintIntl.formatKintMessage({
        id: 'notSet',
        overrideValue: labelOverrides.notSet
      });
    }
    switch (customPropertyDefinition.type) {
      case CUSTPROP_TYPES.MULTI_REFDATA_CLASS_NAME:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.List, {
          items: (_customProperty$value = customProperty.value) === null || _customProperty$value === void 0 ? void 0 : _customProperty$value.map(item => {
            var _item$label;
            return (_item$label = item === null || item === void 0 ? void 0 : item.label) !== null && _item$label !== void 0 ? _item$label : item === null || item === void 0 ? void 0 : item.value;
          }),
          listStyle: "bullets"
        });
      case CUSTPROP_TYPES.REFDATA_CLASS_NAME:
        return (_customProperty$value2 = (_customProperty$value3 = customProperty.value) === null || _customProperty$value3 === void 0 ? void 0 : _customProperty$value3.label) !== null && _customProperty$value2 !== void 0 ? _customProperty$value2 : (_customProperty$value4 = customProperty.value) === null || _customProperty$value4 === void 0 ? void 0 : _customProperty$value4.value;
      case CUSTPROP_TYPES.DECIMAL_CLASS_NAME:
      case CUSTPROP_TYPES.INTEGER_CLASS_NAME:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedNumber, {
          value: customProperty.value
        });
      case CUSTPROP_TYPES.DATE_CLASS_NAME:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FormattedUTCDate, {
          value: customProperty.value
        });
      case CUSTPROP_TYPES.TEXT_CLASS_NAME:
      default:
        return customProperty.value;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Card, {
    headerStart: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: customPropertyDefinition.retired ? kintIntl.formatKintMessage({
          id: 'customProperty.retiredName',
          overrideValue: labelOverrides.retiredName
        }, {
          name: customPropertyDefinition.label
        }) : customPropertyDefinition.label
      }), customPropertyDefinition.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
        content: customPropertyDefinition.description
      }) : null]
    }),
    id: "customproperty-card-".concat(index),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'valueOrValues',
            overrideValue: labelOverrides.valueOrValues
          }),
          children: renderValue()
        })
      }), customProperty !== null && customProperty !== void 0 && customProperty.note ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.internalNote',
            overrideValue: labelOverrides.internalNote
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              whiteSpace: 'pre-wrap'
            },
            children: customProperty.note
          })
        })
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.visibility',
            overrideValue: labelOverrides.visibility
          }),
          children: kintIntl.formatKintMessage({
            id: internalFalse ? 'customProperties.internalFalse' : 'customProperties.internalTrue',
            overrideValue: internalFalse ? labelOverrides.internalFalse : labelOverrides.internalTrue
          })
        })
      }), internalFalse && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.publicNote',
            overrideValue: labelOverrides.publicNote
          }),
          children: customProperty !== null && customProperty !== void 0 && customProperty.publicNote ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              whiteSpace: 'pre-wrap'
            },
            children: customProperty.publicNote
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NoValue, {})
        })
      })]
    })]
  }, "customPropertyCard-".concat(ctx, "[").concat(index, "]"));
};
CustomPropertyCard.propTypes = {
  ctx: _propTypes.default.string,
  customProperty: _propTypes.default.object,
  customPropertyDefinition: _propTypes.default.object,
  index: _propTypes.default.number,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object
};
var _default = exports.default = CustomPropertyCard;